// STEPS is the pipeline's DATA - which artifact each stage owns and which entitlement gates it.
// ProjectPage still reads it for entitlements even though there is no stepper in the UI any more.
//
// The Stepper COMPONENT that used to live here was deleted on 2026-08-03. Nothing had rendered it
// since the pipeline came out of the design, and it was the last holder of two hardcoded slate
// colours - tokenising code nobody runs would have been noise.
const STEPS = [
  { key: 'idea', label: 'Idea', artifact: 'idea_object', cap: { group: 'paths', key: 'idea_input' } },
  { key: 'market', label: 'Market', artifact: 'market_analysis', cap: { group: 'paths', key: 'market' } },
  { key: 'customize', label: 'Customize', artifact: 'customize', cap: { group: 'paths', key: 'customize' } },
  { key: 'build', label: 'Build Pack', artifact: 'build_pack', cap: { group: 'paths', key: 'build_pack' } },
  // The Prototype door (Blueprint = build above): a downloadable working mock app.
  { key: 'prototype', label: 'Prototype', artifact: 'app_mock', cap: { group: 'paths', key: 'app_mock' } },
  { key: 'pathb', label: 'Path B', artifact: 'solution_report', cap: { group: 'paths', key: 'path_b' } },
];

export { STEPS };


